import { Box, IconButton } from "@chakra-ui/react";
import { CrosshairSimpleIcon } from "@phosphor-icons/react/dist/ssr";

// "Re-centrar" — primary CTA shown next to BoundaryButton the moment the
// user drags the camera after a boundary's auto-fit (P6.4). Click snaps
// the camera back to frame the polygon. Visibility is driven by
// BuscarLayout's cameraDragged flag (set true on map dragstart, reset
// false whenever the camera is fitted to a boundary).
//
// Style: solid navy (colorPalette.solid via accent palette) + white text
// (colorPalette.contrast), to read as the primary action when both this
// and Borrar perímetros are showing. Responsive: icon-only square below
// md, icon + label pill at md+ — symmetric with Dibujar / Borrar.
const RecenterButton = ({ onClick }) => {
    const label = "Re-centrar";
    const sharedStyles = {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast",
        borderRadius: "full",
        boxShadow: "md",
        _hover: { bg: "colorPalette.emphasized" },
    };
    return (
        <>
            <Box hideFrom="md">
                <IconButton
                    onClick={onClick}
                    aria-label={label}
                    title={label}
                    size="sm"
                    minW="36px"
                    w="36px"
                    px={0}
                    {...sharedStyles}
                >
                    <CrosshairSimpleIcon weight="bold" />
                </IconButton>
            </Box>
            <Box hideBelow="md">
                <IconButton
                    onClick={onClick}
                    aria-label={label}
                    size="sm"
                    px={4}
                    w="auto"
                    minW="auto"
                    {...sharedStyles}
                >
                    <CrosshairSimpleIcon weight="bold" />
                    <Box as="span" ml={2}>
                        {label}
                    </Box>
                </IconButton>
            </Box>
        </>
    );
};

export default RecenterButton;
